export let DeviceUtil = {
  /**
   * 是否是安卓设备
   */
  isAndroid: function () {
    let u = navigator.userAgent;
    let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
    if (isAndroid) {
      return true;
    } else {
      return false;
    }
  },
  /**
   * 是否是ios设备
   */
  isIOS: function () {
    let u = navigator.userAgent;
    let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (isiOS) {
      return true;
    } else {
      return false;
    }
  },
  /**
   * 是否是微信内部浏览器
   */
  isWeiXin: function () {
    let ua = navigator.userAgent.toLowerCase();
    if (
      ua.match(/MicroMessenger/i) == "micromessenger" ||
      ua.match(/WeiBo/i) == "weibo"
    ) {
      return true;
    } else if (ua.indexOf("mobile mqqbrowser") > -1) {
      return true;
    } else if (ua.indexOf("iphone") > -1 || ua.indexOf("mac") > -1) {
      if (ua.indexOf("qq") > -1) {
        return true;
      }
    }
    return false;
  },
  isMobile() {
    let mobile = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
    return mobile != null;
  },
};
